// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","partnerOffersHeader":"kipabPDlhydM_rVJSkInv","partnerOffersList":"_3WZsD5k7nAkvcI4Xeorkza"};